import React, {createContext, useEffect, useState} from "react";
import {useLocation} from 'react-router-dom'

export const SubNavBarContext = createContext()


export const SubNavBarProvider = ({children}) => {
    const [selectedPage, setSelectedPage] = useState('/admin')
    const location = useLocation()

    useEffect(() => {
        const path = location.pathname.split('/');
        // [0]/[1]admin/[2]goodName/[3]pageName
        setSelectedPage(`/${path[1]}/${path[2]}${path[3] ? '/'+path[3] : ''}`)
    }, [location.pathname])


    return (
        <SubNavBarContext.Provider value={{selectedPage, setSelectedPage}}>
            {children}
        </SubNavBarContext.Provider>
    )
}